import './utils/kickstart';

// packages
import { max } from 'd3-array';
import { nest } from 'd3-collection';
import debounce from 'lodash.debounce';
import { timeParse } from 'd3-time-format';

// utils
import { getSortByString } from './utils/sorters';
import { scaleThreshold, scaleOrdinal } from 'd3-scale';
import { loadJsonScript } from './utils/load-json-script';

// Navbar + linklist buttons
import './components/navbar';
import './components/linklist';

// Closure tracker
import ClosuresCardPicker from './components/reopening/ClosuresCardPicker.svelte';
import CountiesMap from './components/countiesMap/CountiesMap.svelte';

// Changelog
import Changelog from './components/Changelog.svelte';

import { render } from './components/reopening/closuresMap/closuresCaliforniaMap';
import { boot as bootClosuresStackedBar } from './components/reopening/closuresTimeseries';
import * as focusTrap from 'focus-trap'; // ESM

async function main() {
  ///////////////////MODAL/////////////////////////////////////

  var modal = document.querySelector('.m-outer-container');

  var contentContainer = document.querySelector('.m-content-container');
  const trap = focusTrap.createFocusTrap('.m-content-container', {
    onActivate: () => contentContainer.classList.add('is-active'),
    onDeactivate: () => contentContainer.classList.remove('is-active'),
    initialFocus: () => document.querySelector('.m-content-container'),
    escapeDeactivates: false,
  });

  trap.activate();

  // REWRITE THIS TO TARGET MAIN INSTEAD
  var body = document.querySelector('body');
  var main = document.querySelector('main');
  var modal = document.querySelector('.m-outer-container');
  var continueButton = document.querySelector('#continue-to-page');
  var agreementCheckbox = document.querySelector('#agreement-checkbox');
  // screenreader text w/ modal description
  var screenreaderText = document.querySelector('.screenreader-text');

  function freezeBody() {
    body.style.overflow = 'hidden';
    main.setAttribute('aria-hidden', 'true');
  }
  function unfreezeBody() {
    body.style.overflow = 'auto';
    main.setAttribute('aria-hidden', 'false');
    trap.deactivate();
    // modal?.setAttribute('aria-hidden', 'true');
  }

  freezeBody();
  // if checkbox is checked, make "Continue to page clickable"

  function toggleCheckbox(e) {
    // if it's the return key, also make it a click
    if (e.which == 13) {
      e.target.click();
    }
    let cb = e.target;
    if (cb.checked) {
      continueButton.disabled = false;

      // unlock the continue button
    } else {
      continueButton.disabled = true;
    }
  }

  agreementCheckbox.addEventListener('click', toggleCheckbox);
  agreementCheckbox.addEventListener('keypress', toggleCheckbox);

  // turn off modal when you click continue button
  continueButton.addEventListener('click', function () {
    // display none on container
    modal.style.display = 'none';
    // hide screenreader text modal description from screen readers by just display none and w/ aria-hidden just in case
    screenreaderText.style.display = 'none';
    screenreaderText.setAttribute('aria-hidden', 'true');
    // un-fix background
    unfreezeBody();
  });

  /////////end of modal/////////////

  const metricsData = loadJsonScript('closures-metrics');
  const regionalData = loadJsonScript('regions-metrics');
  const regionalTimeseries = loadJsonScript('regions-timeseries');
  const closuresTiersTimeseries = loadJsonScript('closures-tiers-timeseries');
  const tierData = loadJsonScript('closures-data');
  const schoolMapData = loadJsonScript('counties-latest');

  render(
    'overall_status',
    'd3-map-california-closures',
    'overall_status',
    'opening_scale',
    'school-map-container'
  );

  const closuresStackedBar = bootClosuresStackedBar(closuresTiersTimeseries);
  window.addEventListener('resize', debounce(closuresStackedBar, 300));

  const color = scaleOrdinal()
    .domain([1, 2, 3, 4])
    .range(['#802f67', '#c43d53', '#d97641', '#e6b735']);

  new CountiesMap({
    target: document.getElementById('adjusted-case-rate-map'),
    props: {
      data: metricsData.map((d) => ({
        fips: d.fips,
        value: d.adjusted_case_rate,
      })),
      colorScale: (v) => {
        const tier = scaleThreshold().range([4, 3, 2, 1]).domain([1, 4, 7]);
        return color(tier(v));
      },
      showCities: false,
      strokeOnHover: false,
    },
  });

  new CountiesMap({
    target: document.getElementById('positivity-rate-map'),
    props: {
      data: metricsData.map((d) => ({
        fips: d.fips,
        value: d.positivity_rate,
      })),
      colorScale: (v) => {
        const tier = scaleThreshold()
          .range([4, 3, 2, 1])
          .domain([0.02, 0.05, 0.08]);
        return color(tier(v));
      },
      showCities: false,
      strokeOnHover: false,
    },
  });

  new CountiesMap({
    target: document.getElementById('equity-index-map'),
    props: {
      data: metricsData.map((d) => ({ fips: d.fips, value: d.equity_index })),
      colorScale: (v) => {
        if (v == null) {
          return '#cccccc';
        }
        const tier = scaleThreshold()
          .range([4, 3, 2, 1])
          .domain([2.1, 5.2, 8.0]);
        return color(tier(v));
      },
      showCities: false,
      strokeOnHover: false,
    },
  });

  new ClosuresCardPicker({
    target: document.getElementById('closures-cards-container'),
    props: {
      closuresData: loadJsonScript('closures-list'),
      metricsData,
    },
  });

  new Changelog({
    target: document.getElementById('changelog-container'),
    props: loadJsonScript('changelog-data'),
  });
}

main().catch(console.error);

window.addEventListener('load', (event) => {
  var stopScroll = function () {
    $('.tooltip').addClass('invisible');
  };
});
